<template>
	<div v-if="apple_pay_btn_visible">
		<button
			id="apple-pay-button"
			title="Apple Pay"
			@click="onApplePayClick"
			v-bind="ADAattr('label', 'Pay with Apple Pay')"
		></button>
	</div>
</template>

<script>
	import braintree from 'braintree-web';
	import "../includes/apple-pay.min.js";

	export default {
		props: {
			braintree_token: {
				type: String,
				default: '',
			},
			amount_to_pay: {
				type: Number,
				default: '',
			},
		},
		data() {
			return {
				can_make_payments: false,
				apple_pay_btn_visible: false,
				applePayInstance: null
			}
		},

		methods: {
			checkIfApplePayCanBeUsed() {
				this.can_make_payments = true;
				if (!window.ApplePaySession) {
					console.error('This device does not support Apple Pay');
					this.can_make_payments = false;
					return false;
				}
				if (!window.ApplePaySession.canMakePayments()) {
					console.error('This device is not capable of making Apple Pay payments');
					this.can_make_payments = false;
					return false;
				}
				return this.can_make_payments;
			},

			onApplePayClick() {
				if (!this.applePayInstance) return;
				const paymentRequest = this.applePayInstance.createPaymentRequest({
					total: {
						label: 'Textbookx.com',
						amount: this.amount_to_pay
					}
				});
				const session = new window.ApplePaySession(2, paymentRequest);
				session.onvalidatemerchant = event => {
					this.applePayInstance.performValidation({
						validationURL: event.validationURL,
						displayName: 'My Store'
					}).then(merchantSession => {
						session.completeMerchantValidation(merchantSession);
					}).catch(err => {
						this.$emit('error', {message: 'Apple Pay unable to process your request. Please, try again.'});
						this.$emit('error', err);
					});
				};
				session.onpaymentauthorized = event => {
					this.applePayInstance.tokenize({
						token: event.payment.token
					}).then(payload => {
						session.completePayment(ApplePaySession.STATUS_SUCCESS);
						this.$emit('tokenized', payload);
					}).catch(err => {
						session.completePayment(ApplePaySession.STATUS_FAILURE);
						this.$emit('error', err);
					});
				};

				session.begin();
			}

		},
		mounted() {
			if (!this.checkIfApplePayCanBeUsed()) return;

			braintree.client.create({
				authorization: this.braintree_token
			}).then(braintreeClientInstance => {
				return braintree.applePay.create({
					client: braintreeClientInstance
				});
			}).then(applePayInstance => {
				return window.ApplePaySession.canMakePaymentsWithActiveCard(applePayInstance.merchantIdentifier).then(canMakePaymentsWithActiveCard => {
					if (canMakePaymentsWithActiveCard || true) {
						this.applePayInstance = applePayInstance;
						this.apple_pay_btn_visible = true;
					}
				});
			}).catch( err => {
				this.$emit('error', err);
			});
		}
	}
</script>

<style>
	#apple-pay-button {
		width: 250px;
		height: 35px;
		display: inline-block;
		-webkit-appearance: -apple-pay-button;
		-apple-pay-button-type: pay;
		-apple-pay-button-style: white-outline;
		margin-bottom: -6px;
		margin-top: -5px;
	}
</style>